"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepTrim = void 0;

var _TrimmerCanvas = require("../../TrimmerControls/TrimmerCanvas");

var _react = _interopRequireWildcard(require("react"));

var _VideoPlayer = require("../../VideoPlayer");

var _UploadMomentHeader = require("../UploadMomentHeader");

var _UploadMomentFooter = require("../UploadMomentFooter");

var _StepController = require("../../../molecules/StepController");

var _atoms = require("../../../atoms");

var _TrimmerControls = require("../../TrimmerControls");

var _VideoPreview = require("../VideoPreview");

var _useVideoScreenShot2 = require("../../VideoPlayer/useVideoScreenShot");

require("./StepTrim.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Vars
var MAX_CLIP_DURATION = 150.0; // Memoized

var MemoizedTrimmerCanvas = /*#__PURE__*/_react.default.memo(_TrimmerCanvas.TrimmerCanvas, function (prev, next) {
  var _prev$frames, _next$frames;

  return ((_prev$frames = prev.frames) === null || _prev$frames === void 0 ? void 0 : _prev$frames.length) === ((_next$frames = next.frames) === null || _next$frames === void 0 ? void 0 : _next$frames.length);
}); // Step Trim


var StepTrim = function StepTrim(_ref) {
  var name = _ref.name,
      updates = _ref.updates,
      uploading = _ref.uploading,
      tempMoment = _ref.tempMoment,
      onNextStep = _ref.onNextStep,
      buttonTitle = _ref.buttonTitle,
      onCloseClick = _ref.onCloseClick,
      onPreviousStep = _ref.onPreviousStep,
      canPlayLocalVideo = _ref.canPlayLocalVideo,
      uploadingProgress = _ref.uploadingProgress,
      showContentInMobile = _ref.showContentInMobile;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      didAdjust = _useState4[0],
      setDidAdjust = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      forceReload = _useState6[0],
      setForceReload = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isValidTrim = _useState8[0],
      setIsValidTrim = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      tookScreenshots = _useState10[0],
      setTookScreenshots = _useState10[1];

  var _useState11 = (0, _react.useState)(updates.screenshots),
      _useState12 = _slicedToArray(_useState11, 2),
      loadedScreenshots = _useState12[0],
      setLoadedScreenshots = _useState12[1];

  var originalDuration = (0, _react.useRef)(); // Video player container ref

  var videoPlayerContainerRef = (0, _VideoPlayer.useVideoContainerRef)();
  var offScreenVideoPlayerContainerRef = (0, _VideoPlayer.useVideoContainerRef)();

  var _useVideoControls = (0, _VideoPlayer.useVideoControls)(videoPlayerContainerRef),
      jump = _useVideoControls.jump; // Handlers


  var handleOnCloseClick = function handleOnCloseClick() {
    if (typeof onCloseClick === "function") {
      onCloseClick();
    }
  };

  var handleNextStepClick = function handleNextStepClick() {
    if (typeof onNextStep === "function") {
      var newUpdates = {
        startAtRelative: startAt,
        stopAtRelative: stopAt,
        originalVideoDuration: originalDuration.current,
        didAdjustStartTimeOrDuration: didAdjust,
        screenshots: loadedScreenshots
      };
      onNextStep(newUpdates);
    }

    setDidAdjust(false);
    setForceReload(function (old) {
      return old + 1;
    });
  };

  var handlePreviousStepClick = function handlePreviousStepClick() {
    if (typeof onPreviousStep === "function") {
      var newUpdates = {
        startAtRelative: startAt,
        stopAtRelative: stopAt,
        originalVideoDuration: originalDuration.current,
        didAdjustStartTimeOrDuration: didAdjust,
        screenshots: loadedScreenshots
      };
      onPreviousStep(newUpdates);
    }

    setDidAdjust(false);
    setForceReload(function (old) {
      return old + 1;
    });
  }; // Video timing logic


  var momentDuration = updates.stopAtRelative - updates.startAtRelative; // Get video container ref

  var _useVideoInfo = (0, _VideoPlayer.useVideoInfo)(videoPlayerContainerRef),
      duration = _useVideoInfo.duration,
      readyState = _useVideoInfo.readyState;

  var _useVideoScreenShot = (0, _useVideoScreenShot2.useVideoScreenShot)(offScreenVideoPlayerContainerRef),
      takeScreenShot = _useVideoScreenShot.takeScreenShot,
      screenshots = _useVideoScreenShot.screenshots;

  if (updates.startAtRelative === 0 && updates.stopAtRelative === 0) {
    momentDuration = duration;
    originalDuration.current = duration;
  }

  var initialPass = readyState > 1 && parseInt(updates.stopAtRelative) === 0 && parseInt(updates.startAtRelative) === 0;
  var defaultDuration = initialPass ? duration : updates.stopAtRelative - updates.startAtRelative;
  var originalVideoDuration = updates !== null && updates !== void 0 && updates.originalVideoDuration ? updates.originalVideoDuration : duration;

  var _useState13 = (0, _react.useState)(defaultDuration),
      _useState14 = _slicedToArray(_useState13, 2),
      currentDuration = _useState14[0],
      setCurrentDuration = _useState14[1];

  var _useState15 = (0, _react.useState)(updates.startAtRelative),
      _useState16 = _slicedToArray(_useState15, 2),
      startAt = _useState16[0],
      setStartAt = _useState16[1];

  var _useState17 = (0, _react.useState)(updates.stopAtRelative),
      _useState18 = _slicedToArray(_useState17, 2),
      stopAt = _useState18[0],
      setStopAt = _useState18[1];

  var _useState19 = (0, _react.useState)(updates.startAtRelative),
      _useState20 = _slicedToArray(_useState19, 2),
      initialStartAt = _useState20[0],
      setInitialStartAt = _useState20[1];

  var getScreenShotTimes = function getScreenShotTimes(fullDuration) {
    var min = 0;
    var max = fullDuration;
    var items = 7;
    var increments = (max - min) / items;

    var result = _toConsumableArray(Array(items + 1)).map(function (x, y) {
      return +(min + increments * y).toFixed(1);
    });

    return result;
  }; // This is necessary in order to update the stopAt time and duration right aftet the initial
  // load b/c the useVideoInfo hook starts off by sending a default duration of 30s despite
  // the actual length of the video


  (0, _react.useEffect)(function () {
    if (readyState > 1 && parseInt(stopAt - startAt) === 30 && parseInt(stopAt - startAt) !== parseInt(duration)) {
      var initialClipDuration = Math.min(MAX_CLIP_DURATION, duration);
      var validStartTime = parseFloat(duration / 2.0 - initialClipDuration / 2.0);
      var validStopTime = parseFloat(duration / 2.0 + initialClipDuration / 2.0);
      handleOnChangeStartStop(validStartTime, validStopTime);
      setForceReload(function (old) {
        return old + 1;
      });
    }
  }, [readyState, duration]);
  (0, _react.useEffect)(function () {
    if (updates.startAtRelative === 0 && updates.stopAtRelative === 0 && (!currentDuration || currentDuration > momentDuration)) {
      setCurrentDuration(momentDuration);
      setStopAt(momentDuration);
    }
  }, [momentDuration]); // Wait for our screenshots

  (0, _react.useEffect)(function () {
    // Show/hide hood over video
    setLoadedScreenshots(screenshots);
  }, [screenshots]);
  (0, _react.useEffect)(function () {
    if (readyState > 2 && !tookScreenshots && loadedScreenshots.length !== 7) {
      // Take our screenshots
      var screenShotTimes = getScreenShotTimes(originalVideoDuration);
      setTookScreenshots(true);
      takeScreenShot(screenShotTimes);
    }
  }, [readyState, tookScreenshots, originalVideoDuration, loadedScreenshots]); // Handle display of content in mobile

  var showContentInMobileClassName = !showContentInMobile ? "mobile-hide" : "";

  var handleOnChangeStartStop = function handleOnChangeStartStop(newStart, newStop) {
    if (isNaN(newStart) || isNaN(newStop)) return;
    setDidAdjust(true);
    setStartAt(parseFloat(newStart));
    setStopAt(parseFloat(newStop));
    setCurrentDuration(parseFloat(newStop) - parseFloat(newStart));

    if (newStart && parseFloat(newStart).toFixed(2) !== parseFloat(startAt).toFixed(2)) {
      jump(parseFloat(newStart));
    } else if (newStop && parseFloat(newStop).toFixed(2) !== parseFloat(stopAt).toFixed(2)) {
      jump(parseFloat(newStop) - 2.0);
    }
  };

  var handleDisabledButtonClick = function handleDisabledButtonClick() {
    setMessage({
      type: "warning",
      title: "Please wait for your video to finish processing..."
    });
  };

  var videoUrl = "https://go.traceup.com".concat(tempMoment.base_path).concat(tempMoment.dynamic_hls);
  var useableScreenshots = loadedScreenshots ? loadedScreenshots : [];
  var screenshotsLoaded = loadedScreenshots && loadedScreenshots.length === 7;
  return /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: name
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    className: "upload-moment-preview-container",
    xs: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Column,
    md: _atoms.Stack.Type.Column,
    lg: _atoms.Stack.Type.Row
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "upload-moment-preview ".concat(showContentInMobileClassName)
  }, /*#__PURE__*/_react.default.createElement(_UploadMomentHeader.UploadMomentHeader, {
    className: "mobile",
    title: "Trim",
    onBackClick: handlePreviousStepClick,
    onCloseClick: handleOnCloseClick,
    steps: 5,
    index: 4
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "upload-moment-video-container spotlight"
  }, /*#__PURE__*/_react.default.createElement(_VideoPreview.VideoPreview, {
    moment: tempMoment,
    updates: updates,
    duration: currentDuration,
    containerRef: videoPlayerContainerRef,
    startAtOverride: startAt,
    stopAtOverride: stopAt
  }), !screenshotsLoaded && /*#__PURE__*/_react.default.createElement("div", {
    className: "screenshot-player-container"
  }, /*#__PURE__*/_react.default.createElement(_VideoPlayer.VideoPlayer, {
    containerRef: offScreenVideoPlayerContainerRef,
    noMulticam: true,
    moment: tempMoment,
    freeze: true,
    muted: true
  })))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "upload-moment-controls",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_UploadMomentHeader.UploadMomentHeader, {
    className: "desktop",
    title: "Trim",
    onBackClick: handlePreviousStepClick,
    onCloseClick: handleOnCloseClick,
    steps: 5,
    index: 1
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "trimmer-container"
  }, /*#__PURE__*/_react.default.createElement(MemoizedTrimmerCanvas, {
    frames: useableScreenshots
  }), /*#__PURE__*/_react.default.createElement(_TrimmerControls.TrimmerControls, {
    key: forceReload,
    videoUrl: videoUrl,
    type: "uploading",
    moment: tempMoment,
    screenshotsLoaded: screenshotsLoaded,
    stopAt: parseFloat(stopAt).toFixed(2),
    initialStartAt: parseFloat(initialStartAt).toFixed(2),
    startAt: parseFloat(startAt).toFixed(2),
    duration: parseFloat(currentDuration).toFixed(2),
    videoPlayerContainerRef: videoPlayerContainerRef,
    fullGameMomentDuration: originalVideoDuration,
    onChangeStartStop: handleOnChangeStartStop,
    fullGameMoment: tempMoment,
    onChangeIsValidTrim: function onChangeIsValidTrim(isValid) {
      return setIsValidTrim(isValid);
    }
  }))), /*#__PURE__*/_react.default.createElement(_UploadMomentFooter.UploadMomentFooter, {
    message: message,
    uploading: uploading,
    uploadingProgress: uploadingProgress,
    buttonTitle: buttonTitle,
    showButtonIcon: true,
    buttonDisabled: !isValidTrim,
    onButtonClick: handleNextStepClick,
    onDisabledButtonClick: handleDisabledButtonClick,
    canPlayLocalVideo: canPlayLocalVideo
  }))));
};

exports.StepTrim = StepTrim;
StepTrim.defaultProps = {
  showContentInMobile: true,
  onPreviousStep: null,
  tempMoment: null
};